/* eslint-disable no-unused-vars */
import { observable, action, makeObservable, runInAction } from 'mobx';
import { strIsEmpty } from '../utils/tools';
import { getSignUpConfig, getSignUpDescNew, uploadSignUpInfoNew, getEnrollDetail } from '../api/teachingBusiness';
import ToastUtils from '../utils/ToastUtils';
import { toJS } from 'mobx';
import { getAllArea } from '@/api/improveInformation';
import cloneDeep from 'lodash/cloneDeep';
class SignUpStore {
    constructor() {
        makeObservable(this);
    }

    @observable
    relationBusinessId = '';
    @observable
    relationTemplateId = '';
    @observable
    enroll_business_id = '';
    @observable
    enroll_template_id = '';

    @action
    setRelationBusinessId = (data) => {
        this.relationBusinessId = data;
    };

    @action
    setRelationTemplateId = (data) => {
        this.relationTemplateId = data;
    };

    @action
    setEnrollBusinessId = (data) => {
        this.enroll_business_id = data;
    };

    @action
    setEnrollTemplateId = (data) => {
        this.enroll_template_id = data;
    };

    // @action
    // setUploadCompleteInfo = (data) => {
    //     this.uploadCompleteInfo = data;
    // };
    //
    // @action
    // setUploadCompleteInfo = (data) => {
    //     this.uploadCompleteInfo = data;
    // };

    @observable
    uploadCompleteInfo = {};

    @action
    setUploadCompleteInfo = (data) => {
        this.uploadCompleteInfo = data;
    };

    @observable
    signUpDescData = {};

    @action
    setSignUpDescData = (data) => {
        this.signUpDescData = data;
    };

    @observable
    audit_state = null;

    @action
    setAuditState = (auditState) => {
        this.audit_state = auditState;
    };

    @observable
    plaintext_id_card = null;

    @action
    setPlaintextIdCard = (plaintextIdCard) => {
        this.plaintext_id_card = plaintextIdCard;
    };

    @observable
    audit_reason = null;

    @action
    setAuditReason = (auditReason) => {
        this.audit_reason = auditReason;
    };

    @observable
    improve_list = [];

    @observable
    enroll_list = [];

    @observable
    competitionplan_id = '';

    @action
    setCompetitionplanId = (data) => {
        this.competitionplan_id = data;
    };

    @action
    setImproveList = (data) => {
        //需求按顺序显示字段
        // let requiredList = [],
        //     otherList = [],
        //     list;
        // if (data && data.length) {
        //     const configList = toJS(data);
        //     requiredList = configList.filter((item) => item.required === 0);
        //     otherList = configList.filter((item) => item.required !== 0);
        //     list = requiredList.concat(otherList);
        // }
        // console.log(list, '-------------------------------------------');
        this.improve_list = data;
    };
    @action
    setEnrollList = (data) => {
        //需求按顺序显示字段
        // let requiredList = [],
        //     otherList = [],
        //     list;
        // if (data && data.length) {
        //     const configList = toJS(data);
        //     requiredList = configList.filter((item) => item.required === 0);
        //     otherList = configList.filter((item) => item.required !== 0);
        //     list = requiredList.concat(otherList);
        // }
        this.enroll_list = data;
    };
    // 地区列表
    @observable
    area_list = [];

    @action
    setAreaList = (data) => {
        this.area_list = data;
    };
    /**
     * 报名配置
     * @param relationBusinessId
     * @param relationTemplateId
     */
    getSignUpConfig = async () => {
        await getSignUpConfig(this.relationBusinessId, this.relationTemplateId).then((res) => {
            if (res.code === '00000') {
                // this.enroll_template_id = res.data?.enroll_template_id ? res.data?.enroll_template_id : '';
                // this.enroll_business_id = res.data?.enroll_business_id ? res.data?.enroll_business_id : '';

                this.setEnrollBusinessId(res.data?.enroll_business_id ? res.data?.enroll_business_id : '');
                this.setEnrollTemplateId(res.data?.enroll_template_id ? res.data?.enroll_template_id : '');
                // this.getSignUpDesc();
            }
        });
    };

    /**
     * 报名详情
     * @param businessId
     * @param templateId
     * @param relationBusinessId
     * @param relationTemplateId
     */
    getSignUpDesc = async (isRegBtn) => {
        // getSignUpConfig(this.relationBusinessId, this.relationTemplateId).then((res) => {
        //     if (res.code === '00000') {
        //         this.enroll_template_id = res.data?.enroll_template_id ? res.data?.enroll_template_id : '';
        //         this.enroll_business_id = res.data?.enroll_business_id ? res.data?.enroll_business_id : '';
        //         // this.relationBusinessId = this.relationBusinessId ? relationBusinessId : '';
        //         // this.relationTemplateId = relationTemplateId ? relationTemplateId : '';
        //         getSignUpDesc(this.enroll_business_id, this.enroll_template_id, this.relationBusinessId, this.relationTemplateId).then((res2) => {
        //             if (res2.code === '00000') {
        //                 this.setSignUpDescData(res2?.data);
        //                 this.setImproveList(res2?.data?.improve_list);
        //             }
        //         });
        //     }
        // });
        //我的报名 弹窗 调用列表返回的报名的id
        if (isRegBtn !== 1) {
            await this.getSignUpConfig();
        }

        return Promise.all([
            getAllArea(),
            getSignUpDescNew(this.enroll_business_id, this.enroll_template_id, this.relationBusinessId, this.relationTemplateId)
        ]).then((res) => {
            let allAreaList = {};
            let [res1, res2] = res;
            if (res1.code === '00000') {
                allAreaList = res1.data.reduce((acc, item) => {
                    acc[item.code] = item.name;
                    return acc;
                }, {});
            }
            if (res2.code === '00000') {
                this.setSignUpDescData(res2?.data);
                this.setAuditState(res2?.data.audit_state);
                this.setAuditReason(res2?.data.audit_reason);
                if (res2?.data?.plaintext_id_card) {
                    this.setPlaintextIdCard(res2?.data.plaintext_id_card);
                }

                let areaList = [];
                let improveList = res2?.data?.improve_list;
                improveList?.map((item) => {
                    let editValue = cloneDeep(item.value);

                    if (item.field_type === 4) {
                        areaList.push({
                            en_name: item.en_name + '_name',
                            editValue: ''
                        });
                        if (item.value?.length > 0) {
                            let tmp = [];
                            item.value.forEach((code) => {
                                tmp.push(allAreaList[code]);
                            });
                            item.value = tmp.join('');

                            item.areaValue = editValue;
                        }
                    }
                    item.editValue = editValue;
                    item.field_id = item.en_name;
                    item.key = item.en_name;
                });
                if (improveList === undefined || improveList === null || improveList.length === 0) {
                    improveList = [];
                }
                this.setImproveList(improveList);
                let enrollList = res2?.data?.enroll_list;
                enrollList?.map((item) => {
                    let editValue = cloneDeep(item.value);

                    if (item.field_type === 4) {
                        areaList.push({
                            en_name: item.en_name + '_name',
                            editValue: ''
                        });
                        if (item.value?.length > 0) {
                            let tmp = [];
                            item.value.forEach((code) => {
                                tmp.push(allAreaList[code]);
                            });
                            item.value = tmp.join('');

                            item.areaValue = editValue;
                        }
                    }
                    item.editValue = editValue;
                    item.field_id = item.en_name;
                    item.key = item.en_name;
                });
                if (enrollList === undefined || enrollList === null || enrollList.length === 0) {
                    enrollList = [];
                }
                this.setEnrollList(enrollList);
                this.setCompetitionplanId(res2?.data?.plan_id);
                this.setAreaList(areaList);
            }

            return res;
        });
    };

    @observable
    enrollDetail = {};

    @action
    setEnrollDetail = (data) => {
        this.enrollDetail = data;
    };
    /**
     * 大赛报名是否配置了其他赛道
     * @param businessId
     * @param templateId
     */
    getEnrollDetailConfig = async () => {
        await getEnrollDetail(this.relationBusinessId, this.relationTemplateId).then((res) => {
            if (res.code === '00000') {
                this.setEnrollDetail(res?.data);
            }
        });
    };

    @observable
    uploadLoading = false;

    @action
    setUploadLoading = (data) => {
        this.uploadLoading = data;
    };

    // @observable
    // signUpState = false;
    //
    // @action
    // setSignUpState = (data) => {
    //     this.signUpState = data;
    // };

    @observable
    customizeCompetition = [];

    @action
    setCustomizeCompetition = (data) => {
        this.customizeCompetition = data;
    };

    /**
     * 上传报名信息
     * @param relationBusinessId
     * @param relationTemplateId
     * @return true  需要返回上一页，false 不需要返回上一页
     */
    uploadSignUpInfo = async () => {
        let data = {},
            toastMsg = '';
        runInAction(() => {
            this.improve_list?.find((item) => {
                let editValue = item.editValue;
                if (strIsEmpty(editValue)) {
                    item.editValue = '';
                    if (item.required === 0) {
                        toastMsg = `${item.name}不能为空`;
                        // ToastUtils.showToast(toastMsg);
                        ToastUtils.showToast('请完善报名信息');
                        return true;
                    }
                } else {
                    let setting = item.setting,
                        // setting = '{"type": "text", "maxLength": 1}';
                        type = setting.type;
                    if (type === 'text' || type === 'textarea') {
                        let maxLength = setting.maxLength;
                        if (maxLength) {
                            let editValue = item.editValue;
                            if (editValue.length > maxLength) {
                                toastMsg = `${item.name}最多输入${maxLength}个字符`;
                                ToastUtils.showToast(toastMsg);
                                return true;
                            }
                        }
                    }
                }

                data[item.en_name] = item.editValue;
            });
            this.enroll_list?.find((item) => {
                let editValue = item.editValue;
                if (strIsEmpty(editValue)) {
                    item.editValue = '';
                    if (item.field_type === 8 && item.required === 0) {
                        toastMsg = '请上传附件内容';
                        ToastUtils.showToast('请上传附件内容');
                        return true;
                    }
                    if (item.required === 0) {
                        toastMsg = `${item.name}不能为空`;
                        ToastUtils.showToast('请完善报名信息');
                        return true;
                    }
                } else {
                    let setting = item.setting,
                        type = setting.type;
                    if (type === 'text' || type === 'textarea') {
                        let maxLength = setting.maxLength;
                        if (maxLength) {
                            let editValue = item.editValue;
                            if (editValue.length > maxLength) {
                                toastMsg = `${item.name}最多输入${maxLength}个字符`;
                                ToastUtils.showToast(toastMsg);
                                return true;
                            }
                        }
                    }
                    if (item.field_type === 8 && item.required === 0 && !item.editValue.length) {
                        toastMsg = '请上传附件内容';
                        ToastUtils.showToast('请上传附件内容');
                        return true;
                    }
                }

                data[item.en_name] = item.editValue;
            });
            this.customizeCompetition?.find((item) => {
                let editValue = item.editValue;
                if (strIsEmpty(editValue)) {
                    item.editValue = '';
                    if (item.required === 0) {
                        toastMsg = `${item.name}不能为空`;
                        ToastUtils.showToast('请完善报名信息');
                        return true;
                    }
                    if (item.field_type === 8 && item.required === 0) {
                        toastMsg = '请上传附件内容';
                        ToastUtils.showToast('请上传附件内容');
                        return true;
                    }
                } else {
                    let setting = item.setting,
                        type = setting.type;
                    if (type === 'text' || type === 'textarea') {
                        let maxLength = setting.maxLength;
                        if (maxLength) {
                            let editValue = item.editValue;
                            if (editValue.length > maxLength) {
                                toastMsg = `${item.name}最多输入${maxLength}个字符`;
                                ToastUtils.showToast(toastMsg);
                                return true;
                            }
                        }
                    }
                    if (item.field_type === 8 && item.required === 0 && !item.editValue.length) {
                        toastMsg = '请上传附件内容';
                        ToastUtils.showToast('请上传附件内容');
                        return true;
                    }
                }

                data[item.en_name] = item.editValue;
                return false;
            });
            this.area_list?.find((item) => {
                let editValue = item.editValue;
                data[item.en_name] = item.editValue;
                return false;
            });
        });

        // 判断 data 对象中是否包含 'id_card' 属性，并且 this.plaintext_id_card 不为 null
        if ('id_card' in data && this.plaintext_id_card !== null) {
            data['id_card'] = this.plaintext_id_card;
        }
        if (strIsEmpty(toastMsg)) {
            /**
             * ENROLL_UN_START("A1917", "报名时间未开始，不能报名"),
             *  ENROLL_END_ED("A1911", "报名时间已结束，不能报名"),
             *  ENROLL_FINISH("A1912", "您已报名，无法重复报名"),
             *  ENROLL_CONFIG_CHANGE("A1913", "报名配置已变更，请您重新访问"),
             *  ENROLL_QUOTA_EXCEED("A1914", "名额已满，无法报名"),
             *  ENROLL_UN_ACCEPT("A1915", "您不符合报名条件，无法报名"),
             * ENROLL_QUOTA_EXCEED_ADD("A1916", "名额已满，不可再添加名额"),
             * ENROLL_UN_START("A1917", "报名时间未开始，不能报名"),
             */

            try {
                const { code, msg } = await uploadSignUpInfoNew(this.signUpDescData.id, this.relationBusinessId, this.relationTemplateId, data);

                return { code: code, msg: msg };
            } catch (e) {
                return { code: '-2', msg: '报名异常' }; //false
            }
        } else {
            return { code: '-1', msg: toastMsg || '信息填写有误' }; //false
        }
    };

    @action
    clear() {
        // this.relationBusinessId = '';
        // this.relationTemplateId = '';
        // this.enroll_business_id = '';
        // this.enroll_template_id = '';
        this.uploadCompleteInfo = {};
        this.signUpDescData = {};
        this.improve_list = [];
        this.enroll_list = [];
        this.customizeCompetition = [];
        this.area_list = [];
    }
}

export default new SignUpStore();
